export const MuiChip = (palette) => ({
  root: {
    'background-color': palette.primary.light,
    'font-size': '14px',
    'line-height': '16px',
    'margin': '4px',
    'height': '24px',
  },
  label: {
    'white-space': 'initial',
    'padding-left': '12px',
    'padding-top': '4px',
    'padding-right': '12px',
    'padding-bottom': '4px',
  },
  deleteIcon: {
    height: '13px',
    width: '13px',
  },
})
